import { CONVERSATION_API } from 'constants/ResourcesConstants'
import { getAuthorizationHeader, PostJsonHeaders } from 'utils/Helpers'

const BASE = `${ CONVERSATION_API }/targets`

export function fetchTargets() {
  const request = fetch(BASE, {
    method: 'GET',
    headers: getAuthorizationHeader()
  })
  return request.then(res => {
    if (res.ok) {
      return res.json()
    } else {
      throw new Error('Failed to get targets')
    }
  })
}

export function fetchTarget(id) {
  const request = fetch(`${ BASE }/${ id }`, {
    method: 'GET',
    headers: getAuthorizationHeader()
  })
  return request.then(res => {
    if (res.ok) {
      return res.json()
    } else {
      throw new Error('Failed to get target')
    }
  })
}

export function createTarget(target) {
  const request = fetch(BASE, {
    method: 'POST',
    headers: Object.assign(getAuthorizationHeader(), PostJsonHeaders),
    body: JSON.stringify(target)
  })
  return request.then(res => {
    if (res.ok) {
      return res.json()
    } else {
      throw new Error('Failed to create target')
    }
  })
}

export function patchTarget(operations, id) {
  const request = fetch(`${ BASE }/${ id }`, {
    method: 'PATCH',
    headers: Object.assign(getAuthorizationHeader(), PostJsonHeaders),
    body: JSON.stringify(operations)
  })

  return request.then(res => {
    if (res.ok) {
      return res.json()
    } else {
      throw new Error('Failed to update target')
    }
  })
}



// WEBPACK FOOTER //
// ./src/scripts/app/api/TargetAPI.js